/* ============================================================
   Melix Lab 头皮分析 — 计分引擎 (v1)
   ------------------------------------------------------------
   ★ 不要修改这个档案。要改题目/产品/文案 → 改 melix-quiz-config.js
   ============================================================ */

(function (root) {
  "use strict";

  var CFG = root.MELIX_QUIZ_CONFIG;
  var LETTERS = "ABCDEFGH";                       // 单选题编码
  var B32 = "0123456789ABCDEFGHIJKLMNOPQRSTUV";   // 多选题位元遮罩编码

  /* ---------- 各指数原始分上限 (从 config 自动算, 不用手动维护) ---------- */
  function indexMaxes() {
    var max = { oil: 0, blockage: 0, flakes: 0, hydration: 0, sensitivity: 0 };
    CFG.QUESTIONS.forEach(function (q) {
      if (q.type === "single") {
        // 单选: 取该题对每个指数的最大值
        var best = {};
        q.options.forEach(function (o) {
          Object.keys(o.scores || {}).forEach(function (k) {
            best[k] = Math.max(best[k] || 0, o.scores[k]);
          });
        });
        Object.keys(best).forEach(function (k) { max[k] += best[k]; });
      } else {
        // 多选: 全选(除了「都没有」)的总和
        q.options.forEach(function (o) {
          if (o.none) return;
          Object.keys(o.scores || {}).forEach(function (k) {
            max[k] += o.scores[k];
          });
        });
      }
    });
    return max;
  }

  /* ---------- 计分: answers → 5 项指数 (各 /10) ----------
     answers 格式: { q1: 0, q2: 2, q4: [0,2], q6: [] }
     单选 = 选项 index；多选 = 选项 index 阵列 ("都没有"或没选 = 空阵列)
  ------------------------------------------------------------ */
  function scoreAnswers(answers) {
    var raw = { oil: 0, blockage: 0, flakes: 0, hydration: 0, sensitivity: 0 };
    CFG.QUESTIONS.forEach(function (q) {
      var a = answers[q.id];
      var chosen = [];
      if (q.type === "single") {
        if (typeof a === "number" && q.options[a]) chosen = [q.options[a]];
      } else {
        (Array.isArray(a) ? a : []).forEach(function (i) {
          if (q.options[i] && !q.options[i].none) chosen.push(q.options[i]);
        });
      }
      chosen.forEach(function (o) {
        Object.keys(o.scores || {}).forEach(function (k) {
          raw[k] += o.scores[k];
        });
      });
    });

    var max = indexMaxes();
    var scores = {};
    Object.keys(raw).forEach(function (k) {
      var v = max[k] > 0 ? Math.round((raw[k] / max[k]) * 10) : 0;
      scores[k] = Math.min(10, Math.max(0, v));
    });
    return scores;
  }

  /* ---------- 头皮健康指数 (1-10, 毛囊阻塞权重 2 倍) ---------- */
  function healthIndex(scores) {
    var num = 0, den = 0;
    Object.keys(CFG.WEIGHTS).forEach(function (k) {
      num += (scores[k] || 0) * CFG.WEIGHTS[k];
      den += CFG.WEIGHTS[k];
    });
    var v = Math.round(10 - num / den);
    return Math.min(10, Math.max(1, v));
  }

  /* ---------- 头皮性质 (依 config 规则, 由上往下先中先算) ---------- */
  function classifyScalp(scores) {
    // Rules are evaluated in config order:
    // sensitivity first, then dryness, then oiliness.
    for (var i = 0; i < CFG.SCALP_TYPE_RULES.length; i++) {
      var r = CFG.SCALP_TYPE_RULES[i];
      if ((scores[r.index] || 0) >= r.min) return r.type;
    }
    return CFG.SCALP_TYPE_DEFAULT;
  }

  /* ---------- 频率 ---------- */
  function frequencyFor(productId, scores, freqIndex) {
    var rules = CFG.FREQUENCY_RULES[productId] || [];
    var s = scores[freqIndex] || 0;
    for (var i = 0; i < rules.length; i++) {
      if (s >= rules[i].min) return rules[i].text;
    }
    return rules.length ? rules[rules.length - 1].text : "";
  }

  /* ---------- ACTIVATE 04 配对（Q7-Q9） ---------- */
  function activateMatch(answers) {
    answers = answers || {};
    var q7 = Number(answers.q7);
    var q8 = Number(answers.q8);
    var q9 = Number(answers.q9);
    var hasHairFallConcern = q7 === 1 || q7 === 2;
    var hasVolumeConcern = q8 === 0 || q8 === 1 || q8 === 2;
    var product = null;
    var type = "none";

    if (hasHairFallConcern && hasVolumeConcern) {
      product = CFG.ACTIVATE.duo;
      type = "duo";
    } else if (hasHairFallConcern) {
      product = CFG.ACTIVATE.rootguard;
      type = "04a";
    } else if (hasVolumeConcern) {
      product = CFG.ACTIVATE.exoboost;
      type = "04b";
    }

    var habitKeys = ["both", "tonic", "treatment", "neither"];
    var habitKey = habitKeys[q9] || "neither";
    return {
      type: type,
      product: product,
      habitKey: habitKey,
      habitGuidance: CFG.ACTIVATE.habitGuidance[habitKey]
    };
  }

  /* ---------- 头发困扰分数（只用于呈现，不改变原有头皮分类） ---------- */
  function hairConcernScores(answers) {
    answers = answers || {};
    var fallMap = [1, 5, 9];
    var volumeMap = [7, 7, 9, 1];
    var q7 = Number(answers.q7);
    var q8 = Number(answers.q8);
    return {
      hairFall: fallMap[q7] || 1,
      hairVolume: volumeMap[q8] || 1
    };
  }

  function activateRoutineProduct(item, id) {
    return {
      id: id,
      step: item.step,
      name: item.name,
      size: item.size,
      price: item.price,
      versionKey: "activate",
      versionLabel: { en: "", zh: "" },
      variantId: item.variantId,
      img: item.img || "",
      attrs: [],
      reason: item.reason || "",
      frequency: item.frequency || ""
    };
  }

  /* ---------- 推荐: 01-04 连续 Routine + 一个完整购买方案 ---------- */
  function recommend(scalpType, scores, answers) {
    var version = CFG.VERSION_MAP[scalpType] || "dry";
    var products = CFG.PRODUCTS.map(function (p) {
      var v = p.variants[version] || p.variants.dry;
      return {
        id: p.id,
        step: p.step,
        name: p.name,
        size: p.size,
        price: p.price,
        versionKey: version,
        versionLabel: v.label,
        variantId: v.variantId,
        img: v.img || "",
        attrs: p.attrs || [],
        reason: (p.reason && p.reason[version]) || "",
        frequency: (p.frequencyByVersion && (p.frequencyByVersion[version] || p.frequencyByVersion.dry || p.frequencyByVersion.oily)) || frequencyFor(p.id, scores, p.freqIndex)
      };
    });

    var activate = activateMatch(answers);
    if (activate.type === "04a" || activate.type === "duo") {
      products.push(activateRoutineProduct(CFG.ACTIVATE.rootguard, "rootguard"));
    }
    if (activate.type === "04b" || activate.type === "duo") {
      products.push(activateRoutineProduct(CFG.ACTIVATE.exoboost, "exoboost"));
    }

    var setKey = version + "-" + version;
    var setVariantId = CFG.SET.variants[setKey] || CFG.SET.variants["dry-dry"];
    var purchaseCfg = CFG.ROUTINE_PURCHASE[activate.type] || CFG.ROUTINE_PURCHASE.none;
    var purchaseItems = [setVariantId];
    if (activate.type === "04a") purchaseItems.push(CFG.ACTIVATE.rootguard.variantId);
    if (activate.type === "04b") purchaseItems.push(CFG.ACTIVATE.exoboost.variantId);
    if (activate.type === "duo") {
      purchaseItems = [(purchaseCfg.variants && (purchaseCfg.variants[setKey] || purchaseCfg.variants["dry-dry"])) || CFG.ACTIVATE.duo.variantId];
    }

    return {
      version: version,
      products: products,
      setVariantId: setVariantId,
      activate: activate,
      purchase: {
        type: activate.type,
        name: purchaseCfg.name,
        contents: purchaseCfg.contents,
        price: purchaseCfg.price,
        comparePrice: purchaseCfg.comparePrice,
        saveAmount: purchaseCfg.saveAmount,
        img: purchaseCfg.img || (CFG.SET.img[version] || CFG.SET.img.dry || CFG.SET.img.oily),
        variantIds: purchaseItems
      }
    };
  }

  /* ---------- 编码: answers → 9 码 (编号即资料) ---------- */
  function encodeAnswers(answers) {
    var out = "";
    CFG.QUESTIONS.forEach(function (q) {
      var a = answers[q.id];
      if (q.type === "single") {
        var idx = (typeof a === "number") ? a : 0;
        out += LETTERS.charAt(Math.min(idx, q.options.length - 1));
      } else {
        var mask = 0;
        (Array.isArray(a) ? a : []).forEach(function (i) {
          if (q.options[i] && !q.options[i].none) mask |= (1 << i);
        });
        out += B32.charAt(mask);
      }
    });
    return out;
  }

  /* ---------- 解码: 9 码 → answers；兼容旧 6 码报告 ---------- */
  function decodeAnswers(code) {
    if (typeof code !== "string") return null;
    code = code.toUpperCase().replace(/^ML-?/, "").trim();
    var isLegacy = code.length === 6;
    if (!isLegacy && code.length !== CFG.QUESTIONS.length) return null;
    var answers = {};
    for (var qi = 0; qi < code.length; qi++) {
      var q = CFG.QUESTIONS[qi];
      var ch = code.charAt(qi);
      if (q.type === "single") {
        var idx = LETTERS.indexOf(ch);
        if (idx < 0 || idx >= q.options.length) return null;
        answers[q.id] = idx;
      } else {
        var mask = B32.indexOf(ch);
        if (mask < 0) return null;
        var realOpts = 0;
        q.options.forEach(function (o) { if (!o.none) realOpts++; });
        if (mask >= (1 << realOpts)) return null;
        var arr = [];
        for (var b = 0; b < realOpts; b++) {
          if (mask & (1 << b)) arr.push(b);
        }
        answers[q.id] = arr;
      }
    }
    if (isLegacy) {
      answers.q7 = 0;
      answers.q8 = 3;
      answers.q9 = 3;
    }
    return answers;
  }

  function makeReportCode(answers) {
    return "ML-" + encodeAnswers(answers);
  }

  /* ---------- 一次算完整份报告 ---------- */
  function buildReport(answers) {
    var scores = scoreAnswers(answers);
    var hairConcerns = hairConcernScores(answers);
    var health = healthIndex(scores);
    var scalpType = classifyScalp(scores);
    var rec = recommend(scalpType, scores, answers);
    var code = makeReportCode(answers);

    // 分析文案: 基本段 + 最多 2 条高分补充
    var notes = [];
    CFG.INDEXES.forEach(function (ix) {
      if ((scores[ix.key] || 0) >= 6 && CFG.COPY.concernNotes[ix.key]) {
        notes.push({ key: ix.key, score: scores[ix.key], text: CFG.COPY.concernNotes[ix.key] });
      }
    });
    notes.sort(function (a, b) { return b.score - a.score; });
    notes = notes.slice(0, 2).map(function (n) { return n.text; });

    return {
      code: code,
      answers: answers,
      scores: scores,
      hairConcerns: hairConcerns,
      health: health,
      scalpType: scalpType,
      typeIntro: CFG.COPY.typeIntro[scalpType] || "",
      analysis: CFG.COPY.analysis[scalpType] || "",
      concernNotes: notes,
      recommendation: rec
    };
  }

  /* ---------- 储存 (v1 关闭; enabled=false 时什么都不做) ---------- */
  function saveReport(report) {
    var st = CFG.STORAGE || {};
    if (!st.enabled || !st.url) return Promise.resolve(null);

    var params = root.location ? new URLSearchParams(root.location.search) : null;
    var pathLang = root.location && /^\/zh(?:\/|$)/.test(root.location.pathname) ? "zh" : "";
    var language = (params && params.get("lang")) || pathLang || CFG.DEFAULT_LANG || "en";
    var source = (params && (params.get("source") || params.get("src") || params.get("utm_source"))) || "web";
    if (params && params.get("codex_qa") === "1") source = "codex_qa";

    var payload = {
      token: st.token || "",
      report_code: report.code,
      answers: report.answers,
      scores: report.scores,
      hair_concerns: report.hairConcerns,
      scalp_type: report.scalpType,
      status_score: report.health,
      recommended: report.recommendation,
      activate_recommendation: report.recommendation.activate ? report.recommendation.activate.type : "none",
      language: language === "zh" ? "zh" : "en",
      source: source,
      consent_version: st.consentVersion || "v1",
      created_at: new Date().toISOString()
    };

    if (st.provider === "google_apps_script") {
      return fetch(st.url, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(payload)
      }).catch(function () { return null; });
    }

    if (!st.key) return Promise.resolve(null);
    return fetch(st.url.replace(/\/$/, "") + "/rest/v1/scalp_reports", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "apikey": st.key,
        "Authorization": "Bearer " + st.key,
        "Prefer": "return=minimal"
      },
      body: JSON.stringify(payload)
    }).catch(function () { return null; });
  }

  /* ---------- 分析事件 (有什么用什么, 没有就安静跳过) ---------- */
  function track(eventName, params) {
    try {
      if (root.dataLayer && root.dataLayer.push) {
        root.dataLayer.push(Object.assign({ event: eventName }, params || {}));
      }
      if (typeof root.fbq === "function") {
        root.fbq("trackCustom", eventName, params || {});
      }
    } catch (e) { /* 安静跳过 */ }
  }

  /* ---------- WhatsApp 连结 ---------- */
  function whatsappLink(kind, code, url, lang) {
    var tpl = kind === "claim" ? CFG.WHATSAPP.claimText : CFG.WHATSAPP.askText;
    if (tpl && typeof tpl === "object") tpl = tpl[lang] || tpl.en || tpl.zh;
    var text = tpl.replace("{code}", code).replace("{url}", url || "");
    return "https://wa.me/" + CFG.WHATSAPP.number + "?text=" + encodeURIComponent(text);
  }

  root.MELIX_QUIZ_ENGINE = {
    indexMaxes: indexMaxes,
    scoreAnswers: scoreAnswers,
    healthIndex: healthIndex,
    hairConcernScores: hairConcernScores,
    classifyScalp: classifyScalp,
    recommend: recommend,
    activateMatch: activateMatch,
    encodeAnswers: encodeAnswers,
    decodeAnswers: decodeAnswers,
    makeReportCode: makeReportCode,
    buildReport: buildReport,
    saveReport: saveReport,
    track: track,
    whatsappLink: whatsappLink
  };

  if (typeof module !== "undefined" && module.exports) {
    module.exports = root.MELIX_QUIZ_ENGINE;
  }
})(typeof window !== "undefined" ? window : globalThis);
